import { geoCentroid } from "d3-geo";

const getCentroids = (geoData, sortKey = null) => {
  /**
   * Takes geojson object and returns an array of points representing the geographic center
   * of each geographic feature. Properties for each feature are transferered. This is useful
   * for creating bubble maps.
   *
   * The final array can also be sorted by a given key in feature properties. Values will be sorted
   * big to small. This can be useful if you're creating a bubble map and need large bubbles
   * to be layered behind smaller ones.
   *
   * @param geoData (obj): geojson data
   * @param sortKey (optional: str): the name of a property key that you would like to sort the
   * centroids by
   */
  //
  let arrCentroids = geoData.features.map((feature) => {
    const centroid = geoCentroid(feature);
    return { coordinates: centroid, properties: feature.properties };
  });
  // Sort centroids from large to small case counts so that small bubbles
  if (sortKey) {
    arrCentroids = arrCentroids.sort(
      (a, b) => b.properties[sortKey] - a.properties[sortKey]
    );
  }
  return arrCentroids;
};

export default getCentroids;
